import { api } from "@/lib/api/api";
import { config } from "@/lib/shared/config";
import { out } from "@/lib/output/out";
import type { ApiOutputs } from "@/lib/api/api-outputs";

export async function completeLogin(
  baseUrl: string,
  token: string,
): Promise<void> {
  const identity = await api<ApiOutputs["me"]["get"]>("/me", {
    as: { baseUrl, token },
  });
  config.save({
    baseUrl,
    token,
    user: {
      id: identity.user.id,
      name: identity.user.name,
      email: identity.user.email,
    },
  });
  out.line();
  out.line(
    `${out.paint("✓", "green")} Signed in as ${identity.user.email} on ${baseUrl}`,
  );
  out.line(out.paint(`  Session stored in ${config.path}`, "dim"));
}
